<template>
    <div>
        <div class="qty">
            <div class="qty-content-wrapper" @click="goToNextStep(1)">
                <div class="qty-num align-center">
                    &times;1
                </div>
                <div v-if="order.isSampler" class="qty-img-wrapper">
                    <img class="qty-img" src="~home/buy-now/sample_box1.png" alt="Qty 1">
                </div>
                <div v-else class="qty-img-wrapper">
                    <img class="qty-img" src="~home/buy-now/bag1.png" alt="Qty 1">
                </div>
                <div v-if="order.isSampler" class="qty-details-sampler">
                    <p></p>
                    <p>Shipping: <strong>Free</strong></p>
                    <p>Cost: <strong>{{ formatPrice(getTotalPriceCents(1)) }}</strong></p>
                    <p v-if="order.isSampler" class="font-sm">(sampler/set price: <strong>{{ formatPrice(getPricePerBagCents(1)) }}</strong>)</p>
                    <p v-else class="font-sm">(price per bag: <strong>{{ formatPrice(getPricePerBagCents(1)) }}</strong>)</p>
                </div>
                <div v-else class="qty-details">
                    <p></p>
                    <p>Shipping: <strong>Free</strong></p>
                    <p>Cost: <strong>{{ formatPrice(getTotalPriceCents(1)) }}</strong></p>
                    <p v-if="order.isSampler" class="font-sm">(sampler/set price: <strong>{{ formatPrice(getPricePerBagCents(1)) }}</strong>)</p>
                    <p v-else class="font-sm">(price per bag: <strong>{{ formatPrice(getPricePerBagCents(1)) }}</strong>)</p>
                </div>
                <div class="clip-path-inner"></div>
            </div>
            <div v-for="i in bagQuantity">
                <div class="qty-content-wrapper" @click="goToNextStep(i.quantity)">
                    <div class="qty-num align-center">
                        &times;{{ i.quantity }}
                    </div>
                    <div v-if="order.isSampler" class="qty-img-wrapper">
                        <span v-if="i.quantity == 2">
                            <img class="qty-img" src="~home/buy-now/sample_box2.png" alt="Qty 2">
                        </span><span v-else-if="i.quantity == 3">
                            <img class="qty-img" src="~home/buy-now/sample_box3.png" alt="Qty 3">
                        </span><span v-else-if="i.quantity == 4">
                            <img class="qty-img" src="~home/buy-now/sample_box4.png" alt="Qty 4">
                        </span><span v-else-if="i.quantity == 5">
                            <img class="qty-img" src="~home/buy-now/sample_box5.png" alt="Qty 5">
                        </span><span v-else-if="i.quantity == 6">
                            <img class="qty-img" src="~home/buy-now/sample_box6.png" alt="Qty 6">
                        </span><span v-else-if="i.quantity == 7">
                            <img class="qty-img" src="~home/buy-now/sample_box7.png" alt="Qty 7">
                        </span><span v-else-if="i.quantity == 8">
                            <img class="qty-img" src="~home/buy-now/sample_box8.png" alt="Qty 8">
                        </span><span v-else-if="i.quantity == 9">
                            <img class="qty-img" src="~home/buy-now/sample_box8.png" alt="Qty 9">
                        </span><span v-else>
                            <img class="qty-img" src="~home/buy-now/sample_box10.png" alt="Qty 10">
                        </span>
                    </div>
                    <div v-else class="qty-img-wrapper">
                        <span v-if="i.quantity == 2">
                            <img class="qty-img" src="~home/buy-now/bag2.png" alt="Qty 2">
                        </span><span v-else-if="i.quantity == 3">
                            <img class="qty-img" src="~home/buy-now/bag3.png" alt="Qty 3">
                        </span><span v-else-if="i.quantity == 4">
                            <img class="qty-img" src="~home/buy-now/bag4.png" alt="Qty 4">
                        </span><span v-else-if="i.quantity == 5">
                            <img class="qty-img" src="~home/buy-now/bag5.png" alt="Qty 5">
                        </span><span v-else-if="i.quantity == 6">
                            <img class="qty-img" src="~home/buy-now/bag6.png" alt="Qty 6">
                        </span><span v-else-if="i.quantity == 7">
                            <img class="qty-img" src="~home/buy-now/bag7.png" alt="Qty 7">
                        </span><span v-else-if="i.quantity == 8">
                            <img class="qty-img" src="~home/buy-now/bag8.png" alt="Qty 8">
                        </span><span v-else-if="i.quantity == 9">
                            <img class="qty-img" src="~home/buy-now/bag9.png" alt="Qty 9">
                        </span><span v-else>
                            <img class="qty-img" src="~home/buy-now/bag10.png" alt="Qty 10">
                        </span>
                    </div>
                    <div v-if="order.isSampler" class="qty-details-sampler">
                        <p v-if="order.isSampler" class="font-green">{{ i.quantity }} Samplers/Sets Discount: <strong>{{ formatPrice(getDiscountPriceCents(i.quantity)) }}</strong></p>
                        <p v-else class="font-green">{{ i.quantity }} bag discount: <strong>{{ formatPrice(getDiscountPriceCents(i.quantity)) }}</strong></p>
                        <p>Shipping: <strong>Free</strong></p>
                        <p>Cost: <strong>{{ formatPrice(getTotalPriceCents(i.quantity)) }}</strong></p>
                        <p v-if="order.isSampler" class="font-sm">(New sampler/set price:: <strong>{{ formatPrice(getPricePerBagCents(i.quantity)) }}</strong>)</p>
                        <p v-else class="font-sm">(New price per bag: <strong>{{ formatPrice(getPricePerBagCents(i.quantity)) }}</strong>)</p>
                    </div>
                    <div v-else class="qty-details">
                        <p v-if="order.isSampler" class="font-green">{{ i.quantity }} Samplers/Sets Discount: <strong>{{ formatPrice(getDiscountPriceCents(i.quantity)) }}</strong></p>
                        <p v-else class="font-green">{{ i.quantity }} bag discount: <strong>{{ formatPrice(getDiscountPriceCents(i.quantity)) }}</strong></p>
                        <p>Shipping: <strong>Free</strong></p>
                        <p>Cost: <strong>{{ formatPrice(getTotalPriceCents(i.quantity)) }}</strong></p>
                        <p v-if="order.isSampler" class="font-sm">(New sampler/set price:: <strong>{{ formatPrice(getPricePerBagCents(i.quantity)) }}</strong>)</p>
                        <p v-else class="font-sm">(New price per bag: <strong>{{ formatPrice(getPricePerBagCents(i.quantity)) }}</strong>)</p>
                    </div>
                    <div class="clip-path-inner"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BuyNowMixin from '../../../mixins/buy-now-mixin'
    import CommonMixin from "../../../mixins/common-mixin";
    import CoffeeMixin from "../../../mixins/coffee-mixin";
    // Images
    import "home/buy-now/bag1.png";
    import "home/buy-now/bag2.png";
    import "home/buy-now/bag3.png";
    import "home/buy-now/bag4.png";
    import "home/buy-now/bag5.png";
    import "home/buy-now/bag6.png";
    import "home/buy-now/bag7.png";
    import "home/buy-now/bag8.png";
    import "home/buy-now/bag9.png";
    import "home/buy-now/bag10.png";

    import "home/buy-now/sample_box1.png";
    import "home/buy-now/sample_box2.png";
    import "home/buy-now/sample_box3.png";
    import "home/buy-now/sample_box4.png";
    import "home/buy-now/sample_box5.png";
    import "home/buy-now/sample_box6.png";
    import "home/buy-now/sample_box7.png";
    import "home/buy-now/sample_box8.png";
    import "home/buy-now/sample_box9.png";
    import "home/buy-now/sample_box10.png";

    export default {
        mixins: [
            CommonMixin,
            BuyNowMixin,
            CoffeeMixin
        ],
        props: {
            order: Object,
            buyNowDiscounts: Object,
            customBagDiscounts: Array,
            taxRate: Number
        },
        data: function() {
            return  {
                bagQuantity: undefined
            }
        },
        methods: {
            goToNextStep(qty) {
                this.$emit('next', qty)
            },
            getDiscountPriceCents(qty) {
                return this.getDiscountCents(this.order.size, qty, this.buyNowDiscounts, this.customBagDiscounts);
            },
            getTotalPriceCents(qty) {
                let discountCents = this.getDiscountCents(this.order.size, qty, this.buyNowDiscounts, this.customBagDiscounts);
                const totalPriceCents = this.calculateTotalPriceCents(qty, this.order.unitPrice, discountCents);
                return totalPriceCents //this.calcTaxedPriceCents(totalPriceCents, this.taxRate);
            },
            getPricePerBagCents(qty) {
                const totalPrice = this.getTotalPriceCents(qty);
                return totalPrice / qty;
            }
        },
        mounted() {
            this.bagQuantity = this.customBagDiscounts.filter(r => r.custom_size.imperial_uom === this.order.size || r.custom_size.metric_uom === this.order.size ).sort((a, b) => a.quantity - b.quantity);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/_variables_home.scss";
    @import "../../../styles/common_home.scss";

    .qty-content-wrapper {
        display: flex;
        align-items: center;
        width: 100%;
        cursor: pointer;
        position: relative;
        border-bottom: dotted 1px $green;
        .clip-path-inner {
            @include clip-path-inner-rect(rgba(50, 220, 115, 0.1));
        }
        &:hover {
            .clip-path-inner {
                clip-path: circle(100%);
            }
        }
        &:active {
            background-color: $green-light;
        }
    }
    .qty-num {
        font-weight: bold;
        font-size: 26px;
        width: 15%;
    }
    .qty-img-wrapper {
        width: 35%;
    }
    .qty-img {
        width: 100px;
        height: 100px;
    }
    .qty-details {
        width: 50%;
        p {
            margin: 2px;
        }
    }
    .qty-details-sampler {
        width: 60%;
        p {
            margin: 2px;
        }
    }
</style>
